export const tagManager = {
	methods: {
		pushToDataLayer(eventName) {
			if (localStorage.getItem('analytics-cookies') === 'on') {
				window.dataLayer.push({ 'event': eventName });
			}
		}
	}
};